<script lang="ts">
  import { page } from '$app/state'

  const liveChatPaths = ['/contact', '/pricing', '/business', '/help']

  let addLiveChat = $derived(
    liveChatPaths.find((path) => page.url.pathname.startsWith(path)),
  )
</script>

<svelte:head>
  {#if addLiveChat}
    <script type="text/javascript">
      window.$crisp = []
      window.CRISP_WEBSITE_ID = '18d58020-d281-4a03-8775-e6594c92d083'
      ;(function () {
        d = document
        s = d.createElement('script')
        s.src = 'https://client.crisp.chat/l.js'
        s.async = 1
        d.getElementsByTagName('head')[0].appendChild(s)
      })()
    </script>
  {/if}
</svelte:head>
